/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { spacing05 } from '@carbon/layout';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--cds-overlay);
  z-index: var(--z-notification);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
`;

/**
 * @type {import('styled-components').IStyledComponent<'web', {
 *     $width: string;
 * } & React.HTMLAttributes<HTMLDivElement>>}
 */
export const Panel = styled.div`
  width: ${({ $width }) => $width};
  max-width: 90vw;
  background: var(--cm-color-white-base);
  box-shadow: var(--cds-shadow);
  border-left: 1px solid var(--cds-border-subtle);
  display: flex;
  flex-direction: column;
  transform: translateX(0);
  transition: transform 0.3s cubic-bezier(0.2, 0, 0.38, 0.9);
  animation: slideIn 0.3s cubic-bezier(0.2, 0, 0.38, 0.9);

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  &:focus {
    outline: 2px solid var(--cds-focus);
    outline-offset: -2px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing05};
  border-bottom: 1px solid var(--cds-border-subtle);
  flex-shrink: 0;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0;
  margin: 0;
  color: var(--cds-text-primary);
`;

export const Content = styled.div`
  padding: ${spacing05};
  overflow-y: auto;
  flex: 1;
`;
